interface TitleProps {
  children: React.ReactNode;
}

const Title = ({ children }: TitleProps) => {
  return (
    <h2 className="text-[20px] font-bold !font-[B-Nazanin]">{children}</h2>
  );
};

export default Title;
